var React = require('react');

function IconDownload (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M25 20.5V25H7v-4.5H4V25a3.009 3.009 0 0 0 3 3h18a3.009 3.009 0 0 0 3-3v-4.5zm-1.5-6l-2.115-2.115-3.885 3.87V4h-3v12.255l-3.885-3.87L8.5 14.5 16 22z","transform":"translate(-4 -4)"}));
}

IconDownload.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconDownload;

IconDownload.default = IconDownload;
